import { Box } from "@material-ui/core";
import styled from "styled-components";
import { TOOLBAR_OFFSET, maxHeightWithOffset, transition } from "styles/utils";
import { TabList } from "@material-ui/lab";

export const MaterialPreviewContainer = styled(Box)`
    padding: ${({ theme }) => theme.spacing(1)}px ${({ theme }) => theme.spacing(1)}px;
    width: 100%;
    overflow: hidden;
    border-radius: ${({ theme }) => theme.spacing(4)};

    ${maxHeightWithOffset()}
`;

export const MaterialOverviewContainer = styled(Box)`
    flex: 1;
    padding: ${({ theme }) => theme.spacing(1)}px;

    ${maxHeightWithOffset()}
`;

export const MaterialDetailsContainer = styled(Box)`
    top: ${TOOLBAR_OFFSET}px;
    position: sticky;
    align-self: flex-start;
    padding: ${({ theme }) => theme.spacing(1)}px;

    ${maxHeightWithOffset()}
`;

export const AdTabList = styled(TabList)`
    .MuiTab-root {
        text-transform: none;
        min-width: 130px;
    }

    .Mui-selected {
        background-color: ${({ theme }) => theme.palette.primary["200"]};
        font-weight: ${({ theme }) => theme.typography.fontWeightBold};

        :first-of-type {
            border-radius: ${({ theme }) => theme.spacing(0.5)}px 0 0 ${({ theme }) => theme.spacing(0.5)}px;
        }

        :last-of-type {
            border-radius: 0 ${({ theme }) => theme.spacing(0.5)}px ${({ theme }) => theme.spacing(0.5)}px 0;
        }

        ${transition(0.5)};
    }
`;
